import React, {useState} from 'react'
import {FormattedMessage} from 'react-intl'
import Car from '../../assets/imgs/new-vanshare/area/car.svg'
import Station from '../../assets/imgs/new-vanshare/area/station.svg'
import Hokaido from '../../assets/imgs/new-vanshare/area/hokaido.svg'
import Tohoku from '../../assets/imgs/new-vanshare/area/tohoku.svg'
import Kanto from '../../assets/imgs/new-vanshare/area/kanto.svg'
import Chubu from '../../assets/imgs/new-vanshare/area/chubu.svg'
import Hokuriku from '../../assets/imgs/new-vanshare/area/hokuriku.svg'
import Kinki from '../../assets/imgs/new-vanshare/area/kinki.svg'
import Chugoku from '../../assets/imgs/new-vanshare/area/chugoku.svg'
import Shikoku from '../../assets/imgs/new-vanshare/area/shikoku.svg'
import Kyushu from '../../assets/imgs/new-vanshare/area/kyushu.svg'
import { areaInPrefectureList, areaList, AreaType, getPrefecture, ListViewType, UrlPrefix, WHOLE_LOCATION } from '../../config/constants'
import styles from './AreaPrefectureList.scss'
import areaPrefectureCollaspseStyles from '../common/AreaPrefectureCollapse.scss'
import { useLocale, useSm } from '../hocs/hooks'
import { Link } from 'react-router-dom'
import AreaPrefectureCollapse from '../common/AreaPrefectureCollapse'

export const ArePrefectureList = () => {
  const locale = useLocale()
  const [serviceType, setServiceType] = useState(ListViewType.car)
  const isSm = useSm()

  const generateAreaIcon = (area: AreaType) => {
    switch(area) {
      case AreaType.hokkaido:
        return <Hokaido className={styles.icon}/>
      case AreaType.tohoku:
        return <Tohoku className={styles.icon}/>
      case AreaType.kanto:
        return <Kanto className={styles.icon}/>
      case AreaType.chubu:
        return <Chubu className={styles.icon}/>
      case AreaType.hokuriku:
        return <Hokuriku className={styles.icon}/>
      case AreaType.kinki:
        return <Kinki className={styles.icon}/>
      case AreaType.chugoku:
        return <Chugoku className={styles.icon}/>
      case AreaType.shikoku:
        return <Shikoku className={styles.icon}/>
      case AreaType.kyushu:
        return <Kyushu className={styles.icon}/>
      default:
        return <></>
    }
  }

  return <>
  <div className={styles.areaContainer}>
    <div className={['d-flex overflow-auto text-nowrap', styles.tabContainer].join(' ')}>
      <div className={['mr-3', styles.tab, serviceType === ListViewType.car && styles.tabActive].filter(Boolean).join(' ')} onClick={() => setServiceType(ListViewType.car)}>
        <FormattedMessage id="search.van" />
      </div>
      <div className={[styles.tab, serviceType === ListViewType.station && styles.tabActive].filter(Boolean).join(' ')} onClick={() => setServiceType(ListViewType.station)}>
        <FormattedMessage id="search.spotAndActivity" />
      </div>
    </div>
    {/* PC */}
    {!isSm ? <table className={styles.areaTable}>
      <tr className={[styles.row].join(' ')} key={serviceType}>
        <td className={styles.areaItem} colSpan={2}>
          <div className="d-flex align-items-center">
            {serviceType === ListViewType.car
              ? <Car className={styles.icon}/>
              : <Station className={styles.icon}/>
            }
            <Link
              className={['d-flex flex-column align-items-center justify-content-center'].join(' ')}
              to={`/${locale}/${UrlPrefix.user}${serviceType === ListViewType.car  ? 'car-list' : 'stations'}/${WHOLE_LOCATION}?mode=map`}
            >
              <FormattedMessage {...{id: `area.region.${serviceType}`, defaultMessage: serviceType === ListViewType.car ? '全国のキャンピングカー' : '全国の車中泊スポット'}} />
            </Link>
          </div>
        </td>
      </tr>
      {areaList.map((area: AreaType) => <tr className={[styles.row].join(' ')} key={area}>
        <td className={styles.areaItem}>
          <div className="d-flex align-items-center">
            {generateAreaIcon(area)}
            <Link
              className={['d-flex flex-column align-items-center justify-content-center'].join(' ')}
              to={`/${locale}/${UrlPrefix.user}${serviceType === ListViewType.car ? 'car-list' : 'stations'}/${area}/?mode=map`}
            >
              <FormattedMessage {...{id: `area.region.${area}`, defaultMessage: `${area}`}} />
            </Link>
          </div>
        </td>
        <td>
          <div className="d-flex flex-wrap list-unstyled align-items-center">
            {
              areaInPrefectureList[area].map(prefecture => <div className={[styles.prefectureItem].join(' ')}>
                <div className={[styles.prefectureItemText].join(' ')}>
                  <Link
                    to={`/${locale}/${UrlPrefix.user}${serviceType === ListViewType.car ? 'car-list' : 'stations'}/${area}/${prefecture}/?mode=map`}
                  >
                    {getPrefecture(locale, prefecture)}
                  </Link>
                </div>
              </div>
              )
            }
          </div>
        </td>
      </tr>)}
    </table>
    /* SP */
    : <div className={["d-md-none",styles.areaSpMargin].join(' ')}>
      <div className={areaPrefectureCollaspseStyles.areaItem}>
        <div className={['d-flex align-items-center', areaPrefectureCollaspseStyles.areaTitle].join(' ')}>
          {serviceType === ListViewType.car
            ? <Car className={areaPrefectureCollaspseStyles.icon}/>
            : <Station className={areaPrefectureCollaspseStyles.icon}/>
          }
          <Link
            to={`/${locale}/${UrlPrefix.user}${serviceType === ListViewType.car ? 'car-list' : 'stations'}/${WHOLE_LOCATION}?mode=map`}
          >
            <FormattedMessage {...{id: `area.region.${serviceType}`}} />
          </Link>
        </div>
      </div>
      {areaList.map((area: AreaType) => <div key={area}>
        <AreaPrefectureCollapse
          serviceType={serviceType}
          area={area}
          areaIcon={generateAreaIcon(area)}
          prefectures={areaInPrefectureList[area]}
          defaultOpen={false}
          />
      </div>)}
    </div>}
  </div>
</>
}

ArePrefectureList.displayName = 'ArePrefectureList'
export default ArePrefectureList
